import classNames from 'classnames';

import styles from '../TournamentWidget.module.scss';

type ChampionsBetweenRoundsWidgetTrophyProps = {
  src: string;
  className?: string;
  onImageError: (e: React.SyntheticEvent<HTMLImageElement>) => void;
};

export function ChampionsBetweenRoundsWidgetTrophy({
  src,
  className,
  onImageError,
}: ChampionsBetweenRoundsWidgetTrophyProps) {
  return (
    <img
      alt="widget-trophy"
      className={classNames(styles.trophyIconLayer, styles.trophyIconLayerBetweenRounds, className)}
      loading="lazy"
      src={src}
      onError={onImageError}
    />
  );
}
